<p-table [value]="parent.order.OrderItems"
         [resizableColumns]="true"
         [columnResizeMode]="'expand'"
         [autoLayout]="true"
         [styleClass]="'p-datatable-striped'"
         [scrollable]="true"
         [scrollHeight]="'600px'">
    <ng-template pTemplate="header">
        <tr>
            <th pResizableColumn>ID</th>
            <th pResizableColumn>Name</th>
            <th pResizableColumn>Price</th>
            <th pResizableColumn>Qty</th>
            <th pResizableColumn>Total</th>
            <th pResizableColumn>Customer Notes</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
        <tr>
            <td class="ui-resizable-column">{{item.OrderItemId}}</td>
            <td class="ui-resizable-column">{{item.ProductName}}</td>
            <td class="ui-resizable-column">₱ {{item.ProductItemPrice}}</td>
            <td class="ui-resizable-column">{{item.Quantity}}</td>
            <td class="ui-resizable-column">₱ {{item.TotalPrice}}</td>
            <td class="ui-resizable-column">{{item.CustomerNotes}}</td>
        </tr>
    </ng-template>
</p-table>
